module.exports = __webpack_public_path__ + "static/media/flag-checkered-solid.9c1b7a01.svg";